import { Box, Heading, useToast, VStack } from '@chakra-ui/react';
import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import RankingGrid from './RankingGrid';
import RankingDownloadResults from './RankingDownloadResults';
import RankingFullModalGrid from './RankingFullModalGrid';
import RankingResultsCard from './RankingResultsCard';
import RankingResultsTree from './RankingResultsTree';

const RankingResults = ({
  author_email,
  run_id,
  timeStamp,
  API_URL,
  heading,
}) => {
  console.log(timeStamp);
  const [gridData, setGridData] = useState(null);
  const toast = useToast();
  const source = useRef(axios.CancelToken.source()).current;

  // Fetch grid data with memoization to avoid re-fetching on every render
  const fetchGridData = useCallback(async () => {
    try {
      const response = await API_URL.get(
        `get-ranking?author_email=${author_email}&run_id=${run_id}`,
        { cancelToken: source.token }
      );
      setGridData(response.data);
    } catch (error) {
      console.error(error);
      toast({
        title: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, [author_email, run_id, source, toast, API_URL]);

  useEffect(() => {
    fetchGridData();
    return () => {
      source.cancel(); // Cancel any ongoing requests on component unmount
    };
  }, [fetchGridData, source]);

  return (
    <VStack spacing={4}>
      <Heading>{heading}</Heading>
      <Box borderWidth="3px" borderRadius="lg" p="10" width="1150px">
        {timeStamp.jds.length > 5 ? (
          <RankingResultsCard
            timeStamp={timeStamp}
            API_URL={API_URL}
            author_email={author_email}
            run_id={run_id}
          />
        ) : (
          <RankingResultsTree
            timeStamp={timeStamp}
            API_URL={API_URL}
            author_email={author_email}
            run_id={run_id}
          />
        )}

        <Box mx="1" my="2" display="flex" justifyContent="space-between">
          <RankingDownloadResults
            API_URL={API_URL}
            author_email={author_email}
            run_id={run_id}
          />
          <RankingFullModalGrid gridData={gridData} />
        </Box>
        <RankingGrid gridData={gridData} />
      </Box>
    </VStack>
  );
};

export default RankingResults;
